/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PropertyAddress
 */
export interface PropertyAddress {
    /**
     * 
     * @type {string}
     * @memberof PropertyAddress
     */
    address: string;
}

export function PropertyAddressFromJSON(json: any): PropertyAddress {
    return PropertyAddressFromJSONTyped(json, false);
}

export function PropertyAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyAddress {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address': json['address'],
    };
}

export function PropertyAddressToJSON(value?: PropertyAddress | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address': value.address,
    };
}


